export enum ListAction {
  IDLE = 'idle',
  LOAD_OLDER = 'load_older',
  LOAD_NEWER = 'load_newer',
}

export type ListActionCallback = (triggerAction: ListAction) => void;

export type ScrollData = {
  firstItem: Element;
  isScrolledToBottom: boolean;
  lastItem: Element;
  scrollHeight: number;
  scrollTop: number;
};
